import { HTMLAttributes } from 'react'

import { useAppStore } from '@/contexts/store'

import FormSection from './form'

export type NewsletterProps = HTMLAttributes<HTMLDivElement> & {
  theme: 'light' | 'dark'
}

const Newsletter = ({ theme, ...props }: NewsletterProps) => {
  const { strings } = useAppStore()
  return <FormSection theme={theme} {...strings?.newsletter} {...props} />
}

export default Newsletter
